const STRINGS = {
  message: count => {
    return count === 1 ? `Fix 1 error to continue.` : `Fix ${count} errors to continue.`;
  },
  documentTitle: count => {
    return count === 1 ? `Error alert, page contains 1 error.` : `Error alert, page contains ${count} errors.`;
  }
};
export default STRINGS;